export const NAMESPACE = 'device-logs';

export const MOBILE_LOG_LINES_LIMIT = 200;
export const MOBILE_LOG_DISPLAYED_LINES_UPDATE_INTERVAL_MS = 200;

export const MOBILE_LOG_TIME_FORMAT = 'HH:mm:ss';
export const MOBILE_LOG_DATETIME_FORMAT = 'yyyy-MM-dd HH:mm:ss.SSS';
export const MOBILE_LOG_DATETIME_SHORT_FORMAT = 'yyyy-MM-dd_hh-mm';

export const MOBILE_APP_TYPE_FILTER = 'APP';
